export const datasetIncludesPeerset = (
  dataset: any,
  peersetId: string | undefined
) => {
  if (!dataset?.peersets || !peersetId) {
    return false;
  }
  return dataset.peersets.some(
    (peerset) =>
      peerset.datasetId === peersetId ||
      peerset.peersets?.some(({ datasetId }) => datasetId === peersetId)
  );
};
